import { StateCreator } from "zustand";
import { type AuthProfileSerializer } from "@shared/modules/auth/types";
import { type Store } from "../useStore";

/**
 * This slice contains our global authentication state.
 * At this time it only contains the JWT token but could
 * be leveraged to store other authentication related
 * content such as the user profile and permissions.
 */
export const createAuthSlice: StateCreator<Store, [], [], AuthSlice> = (
  set
) => ({
  jwt: undefined,
  user: undefined,

  setJwt(jwt?: string) {
    set({ jwt });
  },

  setUser(user?: AuthProfileSerializer) {
    set({ user });
  },
});

export type AuthSlice = {
  // the JWT token used to authenticate requests
  jwt?: string;
  setJwt(jwt?: string): void;

  // the auth'd user details
  user?: AuthProfileSerializer;
  setUser(user?: AuthProfileSerializer): void;
};
